<template>
  <div class="h-scroll h100-80">
    <div class="h-topo-tree">
     <ejs-treeview ref='MeasureTreeForTask' :fields='fieldsOfMeasureTreeForTask' :nodeSelected='nodeSelectedOfMeasureTreeForTask'></ejs-treeview>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MeasureTreeForTask',
  data() {
    return {
      fieldsOfMeasureTreeForTask: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        tooltip: 'text',
        expanded: 'state'
      },
    };
  },
  methods: {
    // 测量对象树内容获取
    getMeasureObjectTree() {
      this.$axios.get('/lte/pm/buildMeasureObjUnderTaskTree.html?systemId=1').then((response) => {
        this.fieldsOfMeasureTreeForTask = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },

    // 测量对象树点击事件
    nodeSelectedOfMeasureTreeForTask(args) {
      let CounterTypeId = '';
      let MeasureObjectTypeCode = '';
      let NeTypeId = '';
      const attribute = this.$refs.MeasureTreeForTask.getTreeData(args.nodeData.id)[0].attributes;
      if (attribute) {
        NeTypeId = attribute.neTypeId ? attribute.neTypeId : '';
        MeasureObjectTypeCode = attribute.measureObjectTypeCode ? attribute.measureObjectTypeCode : '';
        CounterTypeId = attribute.counterTypeId ? attribute.counterTypeId : '';
      }
      const params = {
        measureObjectTypeCode: MeasureObjectTypeCode,
        counterTypeId: CounterTypeId,
        neTypeId: NeTypeId,
        treeType: '1'
      };

      // 测量对象树点击节点信息事件发布
      this.$emit('transferMeasureObj', params);
    }
  },
  mounted() {
    this.getMeasureObjectTree();
  }
};
</script>

<style>

</style>
